module.exports = __webpack_public_path__ + "static/img/image_support_video_cover_03.fcffa05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_video_cover_03.png
// module id = wwIs
// module chunks = 10